import { createApp } from "vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import App from "./App.vue";
import router from "./router";
import store from "./stores/user-store"; // Import the functions you need from the SDKs you need
import { auth } from "./firebaseConfig"; // Import auth from firebaseConfig.js
import { setupBackgroundListeners } from "./util/backgroundFetch";
import { queryClient, initQueryPersistence } from "./services/queryClient";
import "@/styles/styles.scss";

setupBackgroundListeners();
initQueryPersistence();

createApp(App)
  .use(router)
  .use(store)
  .use(auth)
  .use(VueQueryPlugin, { queryClient })
  .mount("#app");
